import types from './types';
import api from '../../api';
import {asyncSagaConstructor} from '../common';

export default {
   // TODO need to wrap with try/catch here
   getLicense: asyncSagaConstructor(api.license, types.GET_LICENSE, {swallowExceptions: true}),
   getLicenseOptions: asyncSagaConstructor(api.licenseOptions, types.GET_LICENSE_OPTIONS, {
      swallowExceptions: true,
   }),
};
